module.exports = __webpack_public_path__ + "img/smiley_on.17d59347.gif";